module.exports = __webpack_public_path__ + "static/media/mile8.6de5554b.mp3";